/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { SearchResponseDTO } from "../models";
import { SearchResponseDTOFromJSON, SearchResponseDTOToJSON } from "../models";

export interface FindAllEntitiesByFiltersRequest {
  platformId: number;
  skip: number;
  take: number;
  modules?: string;
  searchText?: string;
  searchEAN?: string;
  filters?: string;
}

/**
 *
 */
export class SearchApi extends runtime.BaseAPI {
  /**
   */
  async findAllEntitiesByFiltersRaw(
    requestParameters: FindAllEntitiesByFiltersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SearchResponseDTO>> {
    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling findAllEntitiesByFilters."
      );
    }

    if (requestParameters.skip === null || requestParameters.skip === undefined) {
      throw new runtime.RequiredError(
        "skip",
        "Required parameter requestParameters.skip was null or undefined when calling findAllEntitiesByFilters."
      );
    }

    if (requestParameters.take === null || requestParameters.take === undefined) {
      throw new runtime.RequiredError(
        "take",
        "Required parameter requestParameters.take was null or undefined when calling findAllEntitiesByFilters."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.modules !== undefined) {
      queryParameters["modules"] = requestParameters.modules;
    }

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.skip !== undefined) {
      queryParameters["skip"] = requestParameters.skip;
    }

    if (requestParameters.take !== undefined) {
      queryParameters["take"] = requestParameters.take;
    }

    if (requestParameters.searchText !== undefined) {
      queryParameters["searchText"] = requestParameters.searchText;
    }

    if (requestParameters.searchEAN !== undefined) {
      queryParameters["searchEAN"] = requestParameters.searchEAN;
    }

    if (requestParameters.filters !== undefined) {
      queryParameters["filters"] = requestParameters.filters;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/search`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => SearchResponseDTOFromJSON(jsonValue));
  }

  /**
   */
  async findAllEntitiesByFilters(
    requestParameters: FindAllEntitiesByFiltersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SearchResponseDTO> {
    const response = await this.findAllEntitiesByFiltersRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
